export const SAVE_BUTTON_CLICKED = "save-button-clicked";
export const CLOSE_BUTTON_CLICKED = "close-button-clicked";